export default {
    id: -1,
    name: '',
    price: 0,
    limitations: [],
    is_trial: false,
    trial_discount: 0,
    trial_length_months: 1,
    validity_length_months: 12,
}